export const siteMap = Object.freeze({
	itemsPerPage: 10000
})
